import { Injectable } from "@angular/core";
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { BehaviorSubject } from "rxjs";
import { filter, take } from "rxjs/operators";
import { environment } from '../environments/environment';

@Injectable({
  providedIn: "root"
})
export class BootstrapingService {
  isBootstraped: BehaviorSubject<boolean> = new BehaviorSubject(false);
  angular = window["angular"];

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {}

  bootstrapWings() {
    this.msalService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result) {
          console.log('Login via redirect bem-sucedido!');
          window.sessionStorage.setItem("encodedAccessToken", result.accessToken);
          
          if (result.account) {
            this.msalService.instance.setActiveAccount(result.account);
          }
          
          this.bootstrapLegacyApp();
        } else {
          this.checkIfAccountExistsAndBootstrap();
        }
      },
      error: (error) => {
        console.error('Erro ao processar o redirecionamento do login:', error);
        this.checkIfAccountExistsAndBootstrap();
      }
    });
  }

  private checkIfAccountExistsAndBootstrap() {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        take(1)
      )
      .subscribe(() => {
        const activeAccount = this.msalService.instance.getActiveAccount();
        if (activeAccount) {
          this.validateAccountAndBootstrap(activeAccount);
        } else {
          this.startLogin();
        }
      });
  }

  private validateAccountAndBootstrap(account: any) {
    this.msalService.instance.acquireTokenSilent({
      scopes: environment.apiConfig.scopes,
      account: account
    }).then((response) => {
      window.sessionStorage.setItem("encodedAccessToken", response.accessToken);
      this.bootstrapLegacyApp();
    }).catch((error) => {
      console.error('Falha ao validar conta:', error);
      this.startLogin();
    });
  }

  private startLogin() {
    console.log('Iniciando processo de login...');
    this.msalService.loginRedirect({
      scopes: environment.apiConfig.scopes,
      prompt: 'select_account'
    }).subscribe({
      error: (error) => console.error('Erro ao iniciar o login:', error)
    });
  }

  private bootstrapLegacyApp() {
    if (!this.isBootstraped.getValue()) {
      console.log('A executar o bootstrap do WingsUiAppModule...');
      this.angular.bootstrap(document, ["WingsUiAppModule"]);
      window.location.hash = "/WingsAngular/home";
      this.isBootstraped.next(true);
    }
  }
}
